import { render, staticRenderFns } from "./travelmng.vue?vue&type=template&id=8a8c6a1e&scoped=true"
import script from "./travelmng.vue?vue&type=script&lang=js"
export * from "./travelmng.vue?vue&type=script&lang=js"
import style0 from "./travelmng.vue?vue&type=style&index=0&id=8a8c6a1e&prod&scoped=true&lang=css"
import style1 from "./travelmng.vue?vue&type=style&index=1&id=8a8c6a1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8c6a1e",
  null
  
)

export default component.exports